<div class="dvrim-header">
  <h5 class="dvrim-title">{{ title }}</h5>
  <button type="button" class="dvrim-close" (click)="close()" aria-label="Fechar">
    <i class="fa-regular fa-xmark"></i>
  </button>
</div>

<div class="dvrim" mat-dialog-content>

  <div class="dvrim-tabs" role="tablist">
    <button
      type="button"
      role="tab"
      class="dvrim-tab"
      [class.dvrim-tab-active]="activeTab() === 'images'"
      [attr.aria-selected]="activeTab() === 'images'"
      (click)="selectTab('images')">
      <i class="fa-solid fa-image"></i>
      <span class="dvrim-tab-label">IMAGENS</span>
      <span class="dvrim-tab-badge" [class.dvrim-tab-badge-active]="activeTab() === 'images'">
        {{ imageCount() }}
      </span>
    </button>

    <button
      type="button"
      role="tab"
      class="dvrim-tab"
      [class.dvrim-tab-active]="activeTab() === 'video'"
      [attr.aria-selected]="activeTab() === 'video'"
      (click)="selectTab('video')">
      <i class="fa-solid fa-video"></i>
      <span class="dvrim-tab-label">VÍDEO</span>
      <span class="dvrim-tab-badge" [class.dvrim-tab-badge-active]="activeTab() === 'video'">
        {{ videoCount() }}
      </span>
    </button>

    <button
      type="button"
      role="tab"
      class="dvrim-tab"
      [class.dvrim-tab-active]="activeTab() === 'audio'"
      [attr.aria-selected]="activeTab() === 'audio'"
      (click)="selectTab('audio')">
      <i class="fa-solid fa-microphone"></i>
      <span class="dvrim-tab-label">ÁUDIO</span>
      <span class="dvrim-tab-badge" [class.dvrim-tab-badge-active]="activeTab() === 'audio'">
        {{ audioCount() }}
      </span>
    </button>
  </div>

  <div class="dvrim-content" [class.dvrim-audio-wrap]="activeTab() === 'audio'">
    @switch (activeTab()) {
      @case ('images') {
        @if (imageCount() > 0) {
          <div
            class="dvrim-preview dvrim-preview-image dvrim-preview-clickable"
            (click)="openImagePreview()"
            role="button"
            tabindex="0"
            (keyup.enter)="openImagePreview()"
            aria-label="Expandir imagem">
            @if (selectedImageSrc(); as src) {
              <img [src]="src" [alt]="title" />
            }

            @if (imageCount() > 1) {
              <button
                type="button"
                class="dvrim-nav-arrow dvrim-nav-arrow-prev"
                [disabled]="!canNavigateImagesPrev()"
                (click)="navigateImage(-1, $event)"
                aria-label="Imagem anterior">
                <i class="fa-solid fa-chevron-left"></i>
              </button>
              <button
                type="button"
                class="dvrim-nav-arrow dvrim-nav-arrow-next"
                [disabled]="!canNavigateImagesNext()"
                (click)="navigateImage(1, $event)"
                aria-label="Próxima imagem">
                <i class="fa-solid fa-chevron-right"></i>
              </button>
            }

            <span class="dvrim-preview-expand" aria-hidden="true">
              <i class="fa-solid fa-expand"></i>
            </span>
          </div>
          <div class="dvrim-thumbs-carousel" [class.dvrim-thumbs-carousel-arrows]="showImageArrows()">
            @if (showImageArrows()) {
              <button
                type="button"
                class="dvrim-thumbs-arrow dvrim-thumbs-arrow-prev"
                [disabled]="!canScrollImagesPrev()"
                (click)="scrollImages(-1)"
                aria-label="Miniaturas anteriores">
                <i class="fa-solid fa-chevron-left"></i>
              </button>
            }
            <div
              class="dvrim-thumbs"
              #imageThumbsTrack
              (scroll)="onImagesScroll()">
              @for (image of images(); track image; let i = $index) {
                <button
                  type="button"
                  class="dvrim-thumb"
                  [class.dvrim-thumb-active]="selectedImageIndex() === i"
                  (click)="selectImage(i)"
                  (dblclick)="openImagePreview(i)">
                  <img [src]="getMediaSrc(image)" [alt]="'Miniatura ' + (i + 1)" />
                </button>
              }
            </div>
            @if (showImageArrows()) {
              <button
                type="button"
                class="dvrim-thumbs-arrow dvrim-thumbs-arrow-next"
                [disabled]="!canScrollImagesNext()"
                (click)="scrollImages(1)"
                aria-label="Próximas miniaturas">
                <i class="fa-solid fa-chevron-right"></i>
              </button>
            }
          </div>
        } @else {
          <div class="dvrim-empty">
            <i class="fa-solid fa-image-not-supported"></i>
            <p>Nenhuma imagem anexada</p>
          </div>
        }
      }

      @case ('video') {
        @if (videoCount() > 0 && selectedVideoSrc(); as videoSrc) {
          <div class="dvrim-preview dvrim-preview-video">
            <video
              #videoPlayer
              [src]="videoSrc"
              controls
              playsinline
              preload="metadata"
              (play)="onVideoPlay()"
              (pause)="onVideoPause()"
              (ended)="onVideoPause()">
            </video>
            @if (!isVideoPlaying()) {
              <button type="button" class="dvrim-play-btn" (click)="playVideo()" aria-label="Reproduzir vídeo">
                <i class="fa-solid fa-play"></i>
              </button>
            }
          </div>
          @if (videoCount() > 1) {
            <div class="dvrim-thumbs-carousel" [class.dvrim-thumbs-carousel-arrows]="showVideoArrows()">
              @if (showVideoArrows()) {
                <button
                  type="button"
                  class="dvrim-thumbs-arrow dvrim-thumbs-arrow-prev"
                  [disabled]="!canScrollVideosPrev()"
                  (click)="scrollVideos(-1)"
                  aria-label="Vídeos anteriores">
                  <i class="fa-solid fa-chevron-left"></i>
                </button>
              }
              <div
                class="dvrim-thumbs"
                #videoThumbsTrack
                (scroll)="onVideosScroll()">
                @for (video of videos(); track video; let i = $index) {
                  <button
                    type="button"
                    class="dvrim-thumb dvrim-thumb-video"
                    [class.dvrim-thumb-active]="selectedVideoIndex() === i"
                    (click)="selectVideo(i)">
                    <i class="fa-solid fa-video"></i>
                  </button>
                }
              </div>
              @if (showVideoArrows()) {
                <button
                  type="button"
                  class="dvrim-thumbs-arrow dvrim-thumbs-arrow-next"
                  [disabled]="!canScrollVideosNext()"
                  (click)="scrollVideos(1)"
                  aria-label="Próximos vídeos">
                  <i class="fa-solid fa-chevron-right"></i>
                </button>
              }
            </div>
          }
        } @else {
          <div class="dvrim-empty">
            <i class="fa-solid fa-video-slash"></i>
            <p>Nenhum vídeo anexado</p>
          </div>
        }
      }

      @case ('audio') {
        @if (audio(); as audioData) {
          <div class="dvrim-audio-wrap">
            <app-audio-player
              [audioURL]="audioData.url"
              [duration]="audioData.duration || 20"
              [backgroundColor]="'#F3F4F6'"
              [inputColor]="'#16B097'">
            </app-audio-player>
          </div>
        } @else {
          <div class="dvrim-empty">
            <i class="fa-solid fa-microphone-slash"></i>
            <p>Nenhum áudio anexado</p>
          </div>
        }
      }
    }
  </div>
</div>

@if (galleryImages.length > 0) {
  <ngx-gallery
    class="dvrim-preview-gallery"
    [options]="galleryOptions"
    [images]="galleryImages"
    #previewGallery>
  </ngx-gallery>
}
